<template>
  <form @submit.prevent="handleFormSubmit" class="form">
    <h1 class="heading">{{ $t("password recovery") }}</h1>
    <div class="input-container">
      <label class="label">{{ $t("user name") }}</label>
      <input
        v-model="userName"
        @input="handleUserInput"
        type="text"
        :placeholder="$t('user name')"
        class="input"
      />
    </div>
    <div class="submit">
      <button class="submit-button button filled">
        {{ $t("confirm") }}
      </button>
      <router-link to="/auth/login" class="login-button">{{
        $t("entrance")
      }}</router-link>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      userName: ""
    };
  },
  computed: {
    ...mapGetters(["recoveryErrorMessage"])
  },
  methods: {
    handleUserInput() {
      // Передаем имя пользователя в родительский компонент
      this.$emit("setUserName", this.userName);
      // Если отображалась ошибка, скрываем ее
      if (this.recoveryErrorMessage) {
        this.$store.dispatch("clearRecoveryErrorMessage");
      }
    },
    handleFormSubmit() {
      this.$emit("fetchRecoveryCode", this.userName);
    }
  }
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
}

.heading {
  margin-bottom: 20px;
  font-weight: normal;
  font-size: 36px;
}

.input-container {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.label {
  font-size: 15px;
}

.input {
  width: 70%;
  padding: 10px;
  font-size: 15px;
  outline: none;
  background-color: #ffffff;
  border: 1px solid #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.submit {
  margin-top: 20px;
  width: 70%;
  align-self: flex-end;
  display: flex;
  align-items: center;
}

.submit-button {
  padding: 15px 60px;
}

.login-button {
  margin-left: 18px;
  font-size: 13px;
  color: #acb5c5;
  text-decoration: none;
}
</style>
